<template>
  <div class="user" :class="skinSign">
    <!--    :class="{'hideNav': hideNav}"-->
    <div class="nav">
      <div class="nav-left">
        <div class="logoBox">
          <div class="navLeft-logo" @click="toggleDoveShowStatus">
            <img src="../assets/images/shang/yk.png" alt="">
          </div>
<!--          <div class="line"></div>-->
<!--          <div class="navLeft-text">-->
<!--          </div>-->
        </div>
        <div class="menuBox">
          <div v-for="(item, index) in routers.user" v-if="item.isShow" class="items"
               :class="navIndex === index ? 'itemActive':''">
            <router-link @click="updateLoadingStatus(true)" :to="item.path">
              {{item.name}}
            </router-link>
          </div>
        </div>
      </div>
      <div class="nav-right">
        <img class="sy" src="../assets/images/shang/sy.png" alt="">
        <div v-if="false" class="search">
          <input v-model="searchService" @keypress.13="toServiceCenter" placeholder="搜索您想办的事务" type="text">
          <i @click="toServiceCenter" class="iconfont icon-sousuo"></i>
        </div>
        <div class="login" style="display: none">
          <i class="iconfont icon-geren" style="color: #fff"></i>
          <span>登录</span>
        </div>
        <ul class="menu-list">
          <!--          <li><i class="icon-font bcsxupifu"></i>-->
          <!--            <div class="drop">-->
          <!--              <div class="trangle"></div>-->
          <!--              <div class="seize"></div>-->
          <!--              <ul class="skin-list">-->
          <!--                <li v-if="skin.isShow" @click="changeSkinId(skin.skinId)"-->
          <!--                    :class="{'on':skinSign===skin.skinId}" :style="'background-image: url('+skin.imgSrc+')'"-->
          <!--                    v-for="skin in skinImgList">{{skin.text}}-->
          <!--                </li>-->
          <!--              </ul>-->
          <!--            </div>-->
          <!--          </li>-->
          <li title="全屏切换" @click="toggleFullScreen"><i class="icon-font bcsxuquanpingmu"></i></li>
          <li v-if="getUserLoginStatus" ref="msgIcon" @click="showMsgBox"><i
          class="icon-font bcsxuinformation"></i><span
          v-if="newMsgCount"
          class="point">{{newMsgCount}}</span>
            <div @click="msgDropmenuClick" class="drop">
              <div class="trangle"></div>
              <div class="seize"></div>
              <div class="msginfo">
                <p>您有{{newMsgCount}}个未读消息</p>
                <button @click="setAllMsgSeen">清空</button>
              </div>
              <ul>
                <li @click="showMsgBox" v-for="item in recentMsgList">{{item.title}}</li>
                <li>
                  <button @click="showMsgBox">消息中心</button>
                </li>
              </ul>
            </div>
          </li>
          <li class="userAvatar" @click="toUserCenter"
              :style="`background-image:url(${userInfo.photo?userInfo.photo:''})`" :title="userInfo.username"
              v-if="!getUserLoginStatus"><i v-if="!userInfo.photo" class="icon-font bcsxuiconfontgerenzhongxin"></i>
          </li>
          <li title="后台管理" v-if="userInfo.extend" v-show="userInfo.extend.manager" @click="toManagePanel">
            <i class="iconfont icon-guanlikehu"></i>
          </li>
          <!--          <li v-if="userInfo.extend" v-show="userInfo.extend.manager" @click="showOrderPanel">-->
          <!--            <i class="iconfont icon-guanlikehu"></i>-->
          <!--          </li>-->
          <!--          <li v-if="getUserLoginStatus" title="修改密码" @click="changePassword"><i class="iconfont icon-jjshmima"></i></li>-->
          <li v-if="getUserLoginStatus" title="注销" @click="logout"><i class="icon-font bcsxuswticontuichu"></i></li>
        </ul>
      </div>
    </div>
    <!--    <div class="nav" :class="{'hideNav':hideNav}">-->
    <!--      <div @click="toggleDoveShowStatus" class="logo"></div>-->
    <!--      <ul class="tab-list">-->
    <!--        <li v-if="item.isShow" v-for="(item,index) in routers.user">-->
    <!--          <router-link @click="updateLoadingStatus(true)" :to="item.path">-->
    <!--            <i class="iconfont" :class="'icon-'+item.icon"></i>-->
    <!--            <span>{{item.name}}</span>-->
    <!--            <i v-if="index!==0" class="nail iconfont icon-solidnail"></i>-->
    <!--          </router-link>-->

    <!--        </li>-->
    <!--      </ul>-->
    <!--      <ul class="menu-list">-->
    <!--        <li class="userAvatar" @click="toUserCenter"-->
    <!--            :style="`background-image:url(${userInfo.photo?userInfo.photo:''})`" :title="userInfo.username"-->
    <!--            v-if="isShowTopAvatar"><i v-if="!userInfo.photo" class="iconfont icon-geren"></i>-->

    <!--        </li>-->
    <!--        <li><i class="iconfont icon-huanfu1"></i>-->
    <!--          <div class="drop">-->
    <!--            <div class="trangle"></div>-->
    <!--            <div class="seize"></div>-->
    <!--            <ul class="skin-list">-->
    <!--              <li v-if="skin.isShow" @click="changeSkinId(skin.skinId)"-->
    <!--                  :class="{'on':skinSign===skin.skinId}" :style="'background-image: url('+skin.imgSrc+')'"-->
    <!--                  v-for="skin in skinImgList">{{skin.text}}-->
    <!--              </li>-->
    <!--            </ul>-->
    <!--          </div>-->
    <!--        </li>-->
    <!--        <li v-if="getUserLoginStatus" ref="msgIcon" @click="showMsgBox"><i class="iconfont icon-gezi"></i><span-->
    <!--            v-if="newMsgCount"-->
    <!--            class="point">{{newMsgCount}}</span>-->
    <!--          <div @click="msgDropmenuClick" class="drop">-->
    <!--            <div class="trangle"></div>-->
    <!--            <div class="seize"></div>-->
    <!--            <div class="msginfo">-->
    <!--              <p>您有{{newMsgCount}}个未读消息</p>-->
    <!--              <button @click="setAllMsgSeen">清空</button>-->
    <!--            </div>-->
    <!--            <ul>-->
    <!--              <li @click="showMsgBox" v-for="item in recentMsgList">{{item.title}}</li>-->
    <!--              <li>-->
    <!--                <button @click="showMsgBox">消息中心</button>-->
    <!--              </li>-->
    <!--            </ul>-->
    <!--          </div>-->
    <!--        </li>-->
    <!--        <li title="后台管理" v-if="userInfo.extend" v-show="userInfo.extend.manager" @click="toManagePanel"><i-->
    <!--            class="iconfont icon-guanlikehu"></i></li>-->
    <!--        <li v-if="userInfo.extend" v-show="userInfo.extend.manager" @click="showOrderPanel"><i class="iconfont icon-guanlikehu"></i></li>-->
    <!--        <li v-if="getUserLoginStatus" title="修改密码" @click="changePassword"><i class="iconfont icon-jjshmima"></i></li>-->
    <!--        <li title="全屏切换" @click="toggleFullScreen"><i class="iconfont icon-quanping1"></i></li>-->
    <!--        <li v-if="getUserLoginStatus" title="注销" @click="logout"><i class="iconfont icon-dengchu"></i></li>-->
    <!--      </ul>-->
    <!--    </div>-->

    <!--顶部占位-->
    <div class="rowhold"></div>
    <keep-alive>
      <transition name="routeranim">
        <router-view ref="pageContent" @showCustomService="showCustomService" @fireToolsAction="toolAction"
                     @toServiceDetail="toServiceDetail"></router-view>
      </transition>
    </keep-alive>
    <div class="footer">
      <div class="footer-container">
        <img src="../assets/images/shang/bottomLogo.png" alt="">
        <span>山西药科职业学院版权所有</span>
        <span>晋公网安备 14010502050618号 晋ICP备05007286号</span>
        <span>地址:太原市民航南路16号 </span>
      </div>
      <div class="iframeContainer" v-if="getUserLoginStatus">
        <iframe src="http://ehallapp.czmc.com/default/login.jsp" frameborder="0"></iframe>
      </div>
    </div>
    <div v-if="isShowSideMenu" class="sidemenu">
      <ul class="menulist">
        <!--        <li @click="showKefuModal" class="kefu">-->
        <!--          <span></span>-->
        <!--          <img class="robot" src="../assets/images/robot.png" alt="客服"/>-->
        <!--          <img class="kftext" src="../assets/images/robot_text.png" alt=""/>-->
        <!--        </li>-->
        <!--        <li @click="showFeedback" class="feedback">-->
        <!--                    <span>-->
        <!--                        <i class="iconfont icon-edit"></i>-->
        <!--                    </span>-->
        <!--          <p>留言反馈</p>-->
        <!--        </li>-->
        <li @mouseover="releaseApp" @mouseleave="retractApp" class="application">
                    <span>
                        <i class="iconfont icon-yingyong"></i>
                        <ul class="toolslist" ref="sideToolsList">
                            <div class="seize"></div>
                            <li @click="toolAction(app)" v-for="app in toolsList" :title="app.name"><i class="iconfont"
                                                                                                       :class="app.icon"></i>
                            <img v-if="app.pc_icon" :src="app.pc_icon" alt=""/>
                            </li>


                        </ul>
                    </span>
          <p>小工具</p>
        </li>
        <li @click="toTop" class="toTop">
                    <span>
                        <i class="iconfont icon-tubiao02"></i>
                    </span>
          <p>返回顶部</p>
        </li>
      </ul>
    </div>
    <transition @beforeEnter="doveBeforeEnter" @enter="doveEnter" name="dove">
      <div ref="dove" v-if="isShowDove" :style="doveStyle" class="dove-container">
        <div class="dove">
          <i class="iconfont icon-dove_reverse"></i>
        </div>
      </div>
    </transition>


    <!--loading组件-->
    <loading :isShow="isShowLoading"></loading>
    <!--提示框组件-->
    <notifications position="top right" classes="globalToast" group="global"/>
    <!--全局标准模态框-->
    <service-handle :isShow="isShowServiceHandle" :serviceid="112233" @close="closeModal"></service-handle>
    <order-panel></order-panel>
    <message-box @refreshRecentMsg="refreshRecentMsg" @setNewMsgCount="setNewMsgCount" ref="messageBox"></message-box>
    <message-detail></message-detail>
    <todo></todo>
    <notice></notice>
    <notice-detail></notice-detail>
    <notice-verify-modal></notice-verify-modal>
    <create-notice></create-notice>
    <extra-page></extra-page>
    <modals-container></modals-container>
    <schedule ref="schedule"></schedule>
    <schedule-detail></schedule-detail>
    <transition name="feedback">
      <feedback></feedback>
    </transition>
    <order-detail></order-detail>
    <course-table-modal></course-table-modal>
    <meeting-detail-modal></meeting-detail-modal>
    <profile-verify-panel></profile-verify-panel>
    <transition name="feedback">
      <div v-if="isShowCustomService">
        <custom-service @closeCustomService="closeCustomService"></custom-service>
      </div>
    </transition>
  </div>
</template>

<script>
  //通信总线
  import Bus from 'common/js/bus.js';
  //公共数据
  import {mapState, mapGetters, mapMutations} from 'vuex';
  //服务模态框
  import serviceHandle from "components/service/serviceHandleModal";
  //开放预约窗口
  import orderPanel from "components/order/orderPanelModal";

  // 消息模态框
  import messageBox from "components/message/messageModal";
  // 消息详情
  import messageDetail from "components/message/messageDetailModal"
  //待办模态框
  import todo from "components/todo/todoModal";
  //通知公告模态框
  import notice from "components/notice/noticeModal";
  //通知公告详情模态框
  import noticeDetail from "components/notice/noticeDetailModal";
  //外部页面模态框
  import extraPage from "components/globalComp/extraPageModal";
  //通知公告发布
  import createNotice from "components/notice/createNoticeModal"
  //通知公告审核
  import noticeVerifyModal from "components/noticeVerify/verifyModal"
  //日程模态框
  import schedule from "components/schedule/scheduleModal";
  //日程详情模态框
  import scheduleDetail from "components/schedule/scheduleDetailModal";
  //预约详情
  import orderDetail from 'components/order/orderDetailModal'
  //课表模态框
  import courseTableModal from 'components/course/courseTableModal'
  //会议详情
  import meetingDetailModal from 'components/meeting/meetingDetailModal'
  //个人资料
  //人员资料审核窗口
  import profileVerifyPanel from "components/profileVerify/verifyModal"
  //获取IE版本方法
  import {getIEVersion} from "../common/js/getIEVersion";
  //本地存储存取方法
  import {saveToLocal, loadFromLocal} from "common/js/store";
  //Loading组件
  import loading from "components/globalComp/loading";
  //axios
  import axios from "axios";
  import apiConfig from 'common/js/api_config';
  //日期选择器
  import "static/css/flatpickr.css";
  //截屏工具
  import html2canvas from 'html2canvas'
  //意见反馈
  import feedback from 'components/globalComp/feedbackModal'
  //评分
  import rating from 'components/globalComp/rating'
  //外部页面组件
  import extraPageComp from 'components/globalComp/extraPageComp'
  //客服iframe
  import customService from 'components/globalComp/customService'


  export default {
    name: "user",
    data: function () {
      return {
        searchService: null,
        //皮肤数据
        skinImgList: [
          {
            imgSrc: require("../assets/skin/lan.png"),
            skinId: "blue",
            isShow: 1,
            text: "碧穹蓝",
          },
          {
            imgSrc: require("../assets/skin/hong.png"),
            skinId: "red",
            isShow: 0,
            text: "炽热红",
          },
          {
            imgSrc: require("../assets/skin/zi.png"),
            skinId: "purple",
            isShow: 0,
            text: "梦幻紫",
          },
          {
            imgSrc: require("../assets/skin/lv.png"),
            skinId: "green",
            isShow: 1,
            text: "生机绿",
          },
          {
            imgSrc: require("../assets/skin/cheng.png"),
            skinId: "orange",
            isShow: 0,
            text: "鲜活橙",
          },
          {
            imgSrc: require("../assets/skin/hei.png"),
            skinId: "black",
            isShow: 0,
            text: "神秘黑",
          }
        ],
        //是否隐藏顶栏
        hideNav: false,
        //显示服务弹窗
        isShowServiceHandle: false,
        //是否全屏
        currentIsFullScreen: false,
        //鸽子的样式
        doveStyle: "",
        newMsgCount: 0,
        isShowDove: false,

        //未读消息列表
        recentMsgList: ["消息1消息1消息1消息1消息1消息1消息1", "消息1消息1消息1消息1消息1消息1消息1"],
        isShowCustomService: false,
        // 导航栏状态
        navIndex: 0
      }
    },
    computed: {
      getName() {
        return "用户端"
      },
      showDoveDynamic() {

      },
      ...mapState(['routers', 'isShowLoading', 'isShowSideMenu', 'isShowTopAvatar', 'toolsList', 'apiRequestURL', 'userInfo', 'skinSign', 'profileBaseConfirmState', 'profileExtraConfirmState']),
      ...mapGetters(['getUserLoginStatus', 'getUserSkinSign'])
    },
    watch: {
      newMsgCount(newVal, oldVal) {
        // this.isShowDove = true;
      },
      $route: {
        handler: function (val, oldVal) {
          this.routerChange(val)
        },
        // 深度观察监听
        deep: true
      }
    },
    methods: {
      ...mapMutations(['updateUserInfo', 'updateLoadingStatus', 'updateSystemList', 'updateToolsList', 'updateProfileBaseConfirmState', 'updateProfileExtraConfirmState', 'updateModalZIndex', 'updateDynamicModalZIndex', 'updateImportanceData']),
      ...mapMutations({changeSkinId: 'changeSkinId'}),
      closeModal() {
        this.isShowServiceHandle = false;
        console.log("user:关闭modal");
      },
      // onMenu(index, path) {
      //   if (path === '/website') {
      //     window.open("http://www.bcsxu.edu.cn/", "_blank")
      //   }
      //   this.navIndex = index
      //   Bus.$emit('menuChange');
      // },
      /**
       * 消息轮询
       */
      longPollRequest: function* () {
        yield axios.post(apiConfig.REQUEST_URL + "/shall/front_getMessage");
      },
      longPollBase() {
        if (!this.getUserLoginStatus) {
          console.log('未登录，不轮询:' + this.getUserLoginStatus)
          return
        }
        console.log('%c开启消息轮询', 'font-size:30px;color:#f60')
        let generator = this.longPollRequest();
        let step = generator.next();

        step.value.then((res) => {
          //返回结果处理
          //console.log("新消息：",res.data.data);
          // if (!res.data.status) {
          //   return
          // }
          switch (res.data.status) {
            case 1:
              this.$notify({
                group: 'global',
                title: '温馨提示',
                text: '收到新消息~',
              });
              this.refreshNewMsgCount();
              this.$refs.messageBox.filterMsgList();
              this.isShowDove = true;
              break;
            case 2:
              this.refreshNewMsgCount();
              this.$refs.messageBox.filterMsgList();
          }
          setTimeout(() => {
            this.longPollBase();
          }, 2000)
        })
      },
      //跳转至应用中心
      toServiceCenter() {
        this.$router.push({path: "/service", query: {searchText: this.searchService}})
      },
      //切换全屏
      toggleFullScreen() {

        //进入全屏
        function requestFullScreen() {
          var el = document.documentElement;
          var rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen;
          if (typeof rfs != "undefined" && rfs) {
            rfs.call(el);
          }

          return;
        }

        //退出全屏
        function exitFullscreen() {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
          if (typeof cfs != "undefined" && cfs) {
            cfs.call(el);
          }
        }

        //低版本IE切换全屏
        function toggleIEFullScreen() {
          var el = document.documentElement;
          var rfs = el.msRequestFullScreen;
          if (typeof window.ActiveXObject != "undefined") {
            //这的方法 模拟f11键，使浏览器全屏
            var wscript = new ActiveXObject("WScript.Shell");
            if (wscript != null) {
              wscript.SendKeys("{F11}");
            }
          }
        }


        if (getIEVersion()) {
          if (getIEVersion() <= 11) {
            toggleIEFullScreen();
            return false;
          }
        }
        let hideHeaderTimer;
        window.addEventListener("resize", () => {
          this.hideNav = false;
          this.currentIsFullScreen = false;
        })
        if (this.currentIsFullScreen) {
          exitFullscreen();
          this.currentIsFullScreen = false;
        } else {
          requestFullScreen();
          // hideHeaderTimer = setTimeout(() => {
          //   this.hideNav = true;
          // }, 500);

          this.currentIsFullScreen = true;
        }

      },
      //全局右侧栏应用盒子
      //释放动作
      releaseAppAction(way) {

        let sideToolsList = this.$refs.sideToolsList;
        let sideToolsArr = sideToolsList.getElementsByTagName("li");
        let toolsCount = sideToolsArr.length;

        if (!way) {
          for (let i = 0; i < toolsCount; i++) {

            sideToolsArr[i].style.transform = `translateX(${0}px) translateY(${0}px) rotateZ(0deg)`;
            sideToolsArr[i].style.msTransform = `translateX(${0}px) translateY(${0}px)`;
            sideToolsArr[i].style.webkitTransform = `translateX(${0}px) translateY(${0}px)`;
            sideToolsArr[i].style.opacity = 0;
          }
          return;
        }


        let toolsRadii = 20 + toolsCount * 10;

        let preDeg = (180 / (toolsCount - 1));
        let degs;
        for (let i = 0; i < toolsCount; i++) {
          degs = preDeg * i;
          let toolsPosX = -Math.abs(Math.sin(degs * Math.PI / 180) * toolsRadii);
          let toolsPosY = -Math.cos(degs * Math.PI / 180) * toolsRadii;
          sideToolsArr[i].style.transform = `translateX(${toolsPosX}px) translateY(${toolsPosY}px) rotateZ(720deg)`;
          sideToolsArr[i].style.msTransform = `translateX(${toolsPosX}px) translateY(${toolsPosY}px)`;
          sideToolsArr[i].style.webkitTransform = `translateX(${toolsPosX}px) translateY(${toolsPosY}px)`;
          sideToolsArr[i].style.opacity = 1;
        }
      },
      //释放应用
      releaseApp() {
        this.releaseAppAction(1)

      },
      //收回应用
      retractApp() {
        this.releaseAppAction(0)
      },

      //打开消息窗
      showMsgBox() {
        if (!this.getUserLoginStatus) {
          this.noLoginJump()
          return
        }
        this.$modal.toggle("message");
      },
      //进入服务详情
      toServiceDetail(ev) {
        this.$modal.toggle("serviceHandle");
        console.log(ev)
      },

      //初始化鸽子位置
      initDovePosition() {
        // 新增异常处理
        if (!this.$refs) {
          return
        }
        if (!this.$refs.msgIcon) {
          return
        }

        let msgIconInfo = this.$refs.msgIcon.getBoundingClientRect();
        this.doveStyle = `left:${msgIconInfo.x - 10}px;top:${msgIconInfo.y - 10}px;width:${msgIconInfo.width}px;height:${msgIconInfo.height}px;`;
      },
      toggleDoveShowStatus() {
        return
        this.isShowDove = !this.isShowDove;
      },

      //鸽子动画钩子
      doveBeforeEnter(el) {
        el.style.transition = '1s';
        let x = -window.innerWidth / 2;
        let y = window.innerHeight / 2;
        el.style.transform = `translate3d(${x}px,0,0)`;
        el.querySelector(".dove").style.transform = `translate3d(0,${y}px,0)`;
        el.style.opacity = 1;
      },
      doveEnter(el, done) {
        // 刷新动画效果
        el.offsetWidth;
        el.querySelector(".dove").offsetWidth;
        // 动画完成后的样式
        el.style.transition = "all 1s cubic-bezier(.6,.18,.88,.67)";
        el.style.transform = `translate3d(0,0,0) scale(0.3)`;

        setTimeout(() => {
          el.style.opacity = 0;
          this.isShowDove = !this.isShowDove;
        }, 1000)
        el.querySelector(".dove").style.transform = `translate3d(0,0,0)`;
        // 动画的持续时间
      },
      //去用户中心
      toUserCenter() {
        console.log(this.$router.push({path: '/personal'}));
        if (this.getUserLoginStatus) {
          console.log("用户已登录", this.getUserLoginStatus);
        } else {
          console.log("用户未登录", this.getUserLoginStatus);
        }
      },
      refreshSchedule() {
        this.$refs.schedule.querySchList();
        Bus.$emit('refreshSchCalendar', {type: 0});
      },
      //消息下拉菜单点击：禁用冒泡
      msgDropmenuClick(ev) {
        ev.stopPropagation();
      },
      //全部消息设为已读
      async setAllMsgSeen(ev) {
        this.$refs.messageBox.setAllSeen();
      },
      //获取系统列表
      async getAppList() {
        let appList = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getAppList");
        appList = appList.data.data;
        this.$store.commit('updateSystemList', appList);
      },
      //设置未读消息数
      setNewMsgCount(data) {
        switch (data.type) {
          case "minus":
            this.newMsgCount--;
            break;
          case "allSeen":
            this.newMsgCount = 0;
            break;
          default:
            console.log("setNewMsgCount参数异常：", data.type);
        }
      },
      //刷新未读消息数
      async refreshNewMsgCount() {
        let resp = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getNoReadNum");
        if (resp.data.data) {
          this.newMsgCount = resp.data.data[0];
        }
      },
      //取最近两条消息
      refreshRecentMsg(data) {
        this.recentMsgList = data;
      },
      //去管理面板
      toManagePanel() {
        window.open(apiConfig.REQUEST_URL + '/shall');
      },
      //开放预约（没用了）
      showOrderPanel() {
        this.$modal.show("orderPanel")
      },
      //返回顶部
      toTop() {
        document.getElementsByTagName("html")[0].scrollTop = 0;

      },
      //展示客服框
      showKefuModal() {
        this.isShowCustomService = true;
        Bus.$emit('setCustomServiceZIndexTop')
      },

      //初始化小工具
      async initTools() {
        let toolsData = await axios.post(apiConfig.REQUEST_URL + "/shall/f_getTools");
        toolsData = toolsData.data.data;

        // this.$store.commit('updateToolsList', toolsData);

      },

      //小工具动作
      toolAction(tool) {
        if (!tool) {
          return;
        }
        switch (tool.appid) {
          case 1:
            StartCapture();
            break;
          case 2:
            //日程
            if (!this.getUserLoginStatus) {
              this.noLoginJump(tool)
              return
            }
            this.openSchedule();
            Bus.$emit('setScheduleZIndexTop')
            break;
          case 3:
            //计算器
            this.createModalDynamic(tool.name, tool.pc_url, 700, 700);
            break;
          default:
            //便签、其他
            if (!this.getUserLoginStatus) {
              this.noLoginJump(tool)
              return
            }
            this.openExtraPage(tool);
            Bus.$emit('setExtraPageZIndexTop')
            console.log("打开了后端维护的小工具");
        }
      },
      //截屏
      toScreenShot() {
        html2canvas(document.body).then((canvas) => {
          this.$modal.show("screenShot", {src: canvas.toDataURL("image/png")});
        });
      },
      openSchedule() {
        this.$modal.show("schedule");
      },
      //打开外部页面
      openExtraPage(data) {
        let url = data.pc_url;
        let title = data.name;
        this.$modal.show("extraPage", {url, title});
      },
      //打开意见反馈
      showFeedback() {
        this.$modal.show("feedback");
        Bus.$emit('setFeedbackZIndexTop')
      },
      //注销登录
      logout() {
        //TODO:注销
        console.log("注销");
        location.replace(apiConfig.REQUEST_URL + "/shall/logout");
      },
      //全局测试
      globalTest1() {
        this.createModalDynamic("title", "https://www.baidu.com", 500, 500)
      },
      //创建动态模态框
      /***
       *
       * @param title  标题
       * @param url    外部页面地址
       * @param width  模态框宽度
       * @param height 模态框高度
       */
      createModalDynamic(title, url, width, height) {
        this.$modal.show(extraPageComp, {
          modalTitle: title,
          pageURL: url,
        }, {
          width: width,
          height: height,
          resizable: true,
          reset: true,
          clickToClose: false,
          draggable: '.header'
        }, {
          'before-close': (event) => {
            console.log('this will be called before the modal closes');
          },
          'opened': (event) => {
            this.updateDynamicModalZIndex(event.ref)
          }
        })
      },
      getToolByAppId(appId) {
        for (let i = 0; i < this.toolsList.length; i++) {
          if (this.toolsList[i].appid === appId) {
            return this.toolsList[i]
          }
        }
      },
      //重做登陆前动作
      redoLoginAction() {
        //检测是否需要重做登录前动作
        if (this.$route.query.loginData) {
          let targetJSONStr = this.$route.query.loginData;
          targetJSONStr = targetJSONStr.replace(/\(/g, '{')
          targetJSONStr = targetJSONStr.replace(/\)/g, '}')
          let loginData = JSON.parse(targetJSONStr);
          switch (loginData.type) {
            case "serviceHandle":
              //TODO:服务详情
              this.$modal.show("serviceHandle", {
                guideId: loginData.guideId,
                appid: loginData.serviceId,
                targetTab: loginData.targetTab
              });
              this.$router.push(this.$route.path)
              break;
            case "globalTools":
              setTimeout(() => {
                let toolObj = this.getToolByAppId(loginData.appid)
                this.toolAction(toolObj)
              }, 1000)
              break;
            default:
              console.log(`%c重做登录前操作 类型：${loginData.type}`, "font-size:50px;color:#f60;border:5px solid #000");
          }
        }
      },

      //设置资料状态
      setProfileState() {

        if (!this.getUserLoginStatus) {
          setTimeout(() => {
            this.setProfileState()
          }, 500)
          return
        }

        this.updateProfileBaseConfirmState(this.userInfo.confirm_b)
        this.updateProfileExtraConfirmState(this.userInfo.confirm_p)


        /**
         * activation_open true 强制引导
         *                 false 只能打开个人资料
         */

        let activation_open = this.userInfo.activation_open
        if (!activation_open) {
          return
        }

        if (this.getUserLoginStatus && (!this.profileBaseConfirmState || !this.profileExtraConfirmState || !this.userInfo.confirm_email || !this.userInfo.modify_pwd)) {
          let userType = parseInt(this.userInfo.userType)
          if (userType === 1 || userType === 2) {
            this.$modal.show('profile')
          }
        }
      },

      //开始截图
      startScreenShot() {
        StartCapture()
      },
      //初始化完成动作
      initFinish() {
        //初始截图
        Init()

        document.querySelector('#initLoading').style.opacity = 0
        setTimeout(() => {
          document.querySelector('#initLoading').style.display = 'none'
        }, 300)
      },

      //初始化事件
      initEvent() {
        //返回顶部
        Bus.$on('toTop', this.toTop)
        Bus.$on('logout', this.logout)
      },
      initStylus() {
        this.changeSkinId(this.getUserSkinSign)
      },

      //未登录跳转(小工具)
      noLoginJump(tool) {
        //生成跳转数据
        // let userActionData = {
        //   type: "globalTools",
        //   appid: tool.appid,
        // };
        // let userActionDataStr = JSON.stringify(userActionData);
        // userActionDataStr = userActionDataStr.replace(/{/g, '(')
        // userActionDataStr = userActionDataStr.replace(/}/g, ')')
        location.replace(apiConfig.REQUEST_URL + "/shall/users");
      },
      //关闭客服弹窗
      closeCustomService() {
        this.isShowCustomService = false;
      },
      //展示客服弹窗
      showCustomService() {
        this.isShowCustomService = true;
      },
      //重要程度数据
      async initImportanceGradeData() {
        let importanceGrade = await axios.post(apiConfig.REQUEST_URL + '/shall/f_getImportanceGrade')
        if (!importanceGrade.data.status) {
          return
        }
        this.updateImportanceData(importanceGrade.data.data)
      },
      changePassword() {
        this.$modal.show('changePasswordModal')
      },
      routerChange(val) {
        let routeList = this.routers.user
        let navIndex = null
        routeList.forEach((item, index) => {
          if (val.path === item.path) {
            navIndex = index
          }
        })
        this.navIndex = navIndex
      }
    },
    components: {
      serviceHandle,
      orderPanel,
      loading,
      messageBox,
      todo,
      schedule,
      scheduleDetail,
      notice,
      noticeDetail,
      createNotice,
      extraPage,
      feedback,
      extraPageComp,
      messageDetail,
      orderDetail,
      courseTableModal,
      meetingDetailModal,
      profileVerifyPanel,
      customService,
      noticeVerifyModal,
    },
    mounted() {
      if (document.body.clientWidth < 1030) {
        document.body.style.zoom = 0.48;
      }
      this.routerChange(this.$route)
      //this.$modal.show("message");
      this.initDovePosition();
      //开启轮询
      Bus.$on('userInfoReady', () => {
        this.longPollBase();
      })

      //获取系统列表
      this.getAppList();
      // this.$modal.show("notice");
      this.refreshNewMsgCount();

      //初始化小工具
      this.initTools();
      // this.$modal.show("profile");

      //初始化个人资料
      this.setProfileState();

      //重做登陆前动作
      this.redoLoginAction();

      this.initFinish()

      //设置事件
      this.initEvent()
      //设置样式
      this.initStylus()


      //初始化重要性级别数据
      this.initImportanceGradeData()

      // console.log(document.body.clientWidth)
      // if (document.body.clientWidth <= 1300) {
      //   var t = window.devicePixelRatio   // 获取下载的缩放 125% -> 1.25    150% -> 1.5
      //   document.body.style.zoom =0.6/ t;   // 就去修改页面的缩放比例
      // }
      // if (document.body.clientWidth <= 1600) {
      //   var t = window.devicePixelRatio   // 获取下载的缩放 125% -> 1.25    150% -> 1.5
      //   document.body.style.zoom =0.7/ t;   // 就去修改页面的缩放比例
      //
      // }

    }
  }
</script>

<style lang="stylus" scoped>
  @import "../common/stylus/config.styl"

  @media screen and (max-width: 1910px)
    .user
      min-width 1440px !important

      .nav
        min-width 1440px !important
    //.sy
    //  display none
    .search
      display none
    @media screen and (max-width: 1510px)
      .nav
        padding 0 20px !important
        .logoBox
          width 500px !important
        .line
          display none
        .navLeft-text
          display none
  .menu-list
    li:last-child
      margin-right 0 !important

  .user
    height 100%
    min-width 1666px

    .rowhold
      height 0px

    .nav
      width 100%
      min-width 1635px
      height 80px
      background #437EE1
      z-index 1000
      position fixed
      transition 300ms
      display flex
      justify-content space-between
      padding 0 41px
      box-sizing border-box

      &.hideNav
        margin-top -80px

      .nav-left
        height 100%
        float left
        .logoBox
          width 620px
          height 100%
          // display flex
          align-items center
          float left
          line-height 80px

          .navLeft-logo
            width 483px
            height 49px
            cursor pointer
            float left
            position relative
            top 50%
            transform translateY(-50%)

            img
              width 100%
              height 100%
              float left

          .line
            width 1px
            height 40px
            background #ffffff
            margin 0 16px 0 21px
            vertical-align middle
            float left
            position relative
            top 50%
            transform translateY(-50%)

          .navLeft-text
            font-size 22px
            color #ffffff
            font-weight bold
            float left

        .menuBox
          display flex
          height 80px
          float left
          position relative
          z-index 9999
          @media screen and (max-width: 1550px)
            .items
              padding 0 16px !important

          .items
            width auto
            padding 0 20px
            height 100%
            font-size 18px
            font-weight 500
            transition .5s
            float left
            text-align center
            line-height 80px
            white-space nowrap

            &:hover
              background #3C73D0

            & a
              width 100%
              height 100%
              display flex
              align-items center
              justify-content center
              color rgba(255, 255, 255, 1)
              cursor pointer
              font-weight bold

          .itemActive
            background #3C73D0

      .nav-right
        height 100%
        float right
        vertical-align middle
        .sy
          width 180px
          height 55px
          float left
          position absolute
          right 200px
          top 50%
          transform translateY(-50%)
          margin-right 50px
        .search
          width 190px
          height 32px
          background #ffffff
          border-radius 5px
          overflow hidden
          padding 5px 10px
          box-sizing border-box
          margin-right 40px
          float left
          position relative
          top 50%
          transform translateY(-50%)

          .icon-sousuo
            cursor pointer
            float right
            position relative
            top 50%
            transform translateY(-50%)

          input
            width 80%
            height 100%
            font-size 12px
            color #777777

        .login
          cursor pointer
          position relative
          top 50%
          transform translateY(-50%)
          float right

          span
            font-size 16px
            color #ffffff
            margin-left 3px

  .menu-list
    float right
    margin-top 25px

    & > li
      float left
      width 26px
      height 26px
      line-height 25px
      color #ffffff
      text-align center
      margin-right 15px
      position relative
      transition 300ms
      cursor pointer

      &.userAvatar
        background-size contain

      i
        font-size 21px
        line-height 28px

      &:hover .drop
        transform scaleY(1)
        display block

      &:last-of-type
        margin-right 30px

      & > .point
        position absolute
        right -4px
        top -4px
        background-color #bf2425
        font-size 9px
        line-height 12px
        height 12px
        width 12px
        border-radius 50%
        overflow hidden
        text-overflow ellipsis
        white-space nowrap

      & > .drop
        position absolute
        right -21px
        top 140%
        width 366px
        height 216px
        color #f60
        padding-left 16px
        padding-right 16px
        background-color #ffffff
        transform scaleY(0)
        transform-origin top center
        transition 300ms
        border-radius 5px
        z-index 999
        box-shadow 0 2px 6px #cccccc

        .trangle
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-bottom: 12px solid #ffffff;
          position absolute
          right 26px
          top -12px

        .seize
          position absolute
          right 15px
          top -12px
          width 40px
          height 50px

        //消息下拉

        .msginfo
          height 75px
          line-height 75px
          padding-left 20px
          border-bottom 1px solid #eeeeee
          margin-bottom 5px
          text-align left
          position relative

          button
            position absolute
            right 20px
            top 0
            bottom 0
            margin auto
            width 50px
            height 30px
            border-radius 5px
            border 1px solid #e5e5e5
            outline none
            background-color #ffffff

          p
            font-size 14px
            color #999999

        ul
          margin-top 10px

          li
            color #999999
            font-size 12px
            line-height 30px
            white-space nowrap
            overflow hidden
            text-overflow ellipsis

            &:last-of-type
              border-bottom none

              button
                width 100px
                height 30px
                border-radius 5px
                border 1px solid #e5e5e5
                outline none
                background-color #ffffff
                margin 8px

        .skin-list
          margin-top 25px

          &::after
            content ""
            width 100%
            height 0
            clear both
            display block

          li
            width 100px
            height 70px
            line-height 70px
            text-align center
            color #ffffff
            float left
            margin-right 14px
            margin-bottom 14px
            background-repeat no-repeat
            background-size cover
            cursor pointer

            &:nth-of-type(3n)
              margin-right 0

            &.on
              transform scale(1.1)


  .footer
    width 100%
    height 50px
    background-color #437EE1
    clear both
    overflow hidden
    position fixed
    bottom 0
    left 0
    z-index 999

    .footer-container
      height 100%
      width 1136px
      margin auto
      white-space nowrap
      text-align center
      line-height 50px

      img
        width 30px
        height 30px
        position relative
        top 50%
        transform translateY(-50%)

      span
        font-size 12px
        color #FFFFFF !important
        margin-left 15px

      i
        position relative
        top 1.8px

      .iframeContainer
        iframe
          width 0
          height 0

  /*侧边栏*/

  .sidemenu
    position fixed
    -webkit-transform: translateZ(0);
    width 131px
    top 0
    bottom 0
    right -88px
    height 120px
    margin auto
    z-index 99999

    .menulist
      & > li
        height 40px
        border-top-left-radius 20px
        border-bottom-left-radius 20px
        position relative
        margin-bottom 10px
        cursor pointer
        transition 300ms

        &:hover
          transform translateX(-88px)
          background-color #36a327

        p
          color #ffffff
          line-height 40px
          text-align center
          padding-left 25px
          font-size 14px
          opacity 0.8

      .kefu
        background-color #ed4343

        &:hover .robot
          //animation robotjump 1.2s 1 cubic-bezier(.18, .77, .76, .7)
          animation jump ease 1.5s 1

        &::after
          content ''
          display block
          width 200px
          height 80px
          position relative
          top -35px

        .robot
          /*border 1px solid #f0f*/
          position absolute
          left 0
          bottom 0
          transition 300ms

        & > span
          width 35px
          height 35px
          border-radius 50%
          position absolute
          left 5px
          border 5px solid #f48b4b
          background-color #faef3c

        .kftext
          position absolute
          top 10px
          left 46px

      .feedback, .toTop, .application
        span
          width 35px
          height 35px
          float left
          position absolute
          left 12px

          i
            font-size 20px
            line-height 40px
            color #ffffff
            opacity 0.8

      .feedback
        z-index 2
        background-color #026da5

      .application
        background-color: #548edf

        &:hover .seize
          display block !important

        span
          position relative
          display inline-block

          .toolslist
            .seize
              width 200px
              height 200px
              background-color rgba(0, 0, 0, 0)
              position absolute
              right -80px
              top -70px
              display none

            li
              width 35px
              height 35px
              line-height 35px
              text-align center
              border-radius 50%
              background-color #ffffff
              position absolute
              box-shadow 2px 2px 8px #999999
              left -10px
              top 0
              transition 300ms
              //transition 300ms cubic-bezier(.53,1.45,1,1)
              opacity 0

              &:hover
                background-color #eeeeee

              & > img
                position absolute
                left 0
                top 0
                width 100%
                height 100%

              i
                color #333333

      .toTop
        background-color #d6dbe5

  & >>> .msgModal
    border 5px solid #f60 !important
    background-color #f0f !important

  //信息鸽子
  .dove-container
    text-align center
    z-index 999
    position fixed
    left 0
    top 0
    width 200px
    height 200px
    transition 1s
    //transition: all 0.4s cubic-bezier(0.49, -0.29, 0.75, 0.41)

    .dove
      width 100%
      height 100%
      transition 1s cubic-bezier(.08, .69, .82, 1)

      i
        //color rgba(51,116,170,0.5)
        opacity 0.5
        color: #3374aa
        text-shadow 2px 2px 5px #666666
        font-size 100px

  /*绿色版皮肤*/
  .user.green
    .nav
      .logo
        background-color themeColor

      .router-link-active
        color themeColor !important

      .menu-list
        & > li
          background-color themeColor

  /*路由切换动画*/
  .routeranim-enter
    opacity 0
    transform translate3d(200px, 0, 0)
    transition 300ms

  .routeranim-leave-to
    display none
    overflow visible
    height 0

  .routeranim-enter-active, .routeranim-leave-active
    transition: all 300ms ease-out;


  /*路由切换动画*/
  .feedback-enter
    opacity 0
    transition 500ms

  .feedback-leave-to
    display none
    overflow visible
    height 0

  .feedback-enter-active, .feedback-leave-active
    transition: all 500ms ease-out;

  /***
  ###################[ keyframe动画 ]#####################
   */
  @keyframes robotjump
    0%
      transform translateY(0)
    25%
      transform translateY(-16px)
    50%
      transform translateY(0)
    75%
      transform translateY(-6px)
    100%
      transform translateY(0)

</style>

<style lang="stylus">

  @import "../common/stylus/config.styl"
  /***
  ###################[ 全局样式 ]#####################
 */

  //数据为空提示
  .empty
    font-size 18px
    color #dddddd
    width 100%
    height 1em
    line-height 1
    text-align center
    position absolute
    z-index 9
    top 0
    bottom 0
    margin auto


  /**
  设置弹窗的全局样式
   */
  .v--modal-overlay
    background-color rgba(0, 0, 0, 0.6)

    .generalbox
      // transition 300ms cubic-bezier(0.68, -0.55, 0.27, 1.55)
      background-color #ffffff
      overflow hidden

      .header
        border 1px solid #e7e7e7
        background-color #fdfdfd
        height 50px
        line-height 50px
        padding-left 28px
        position relative
        z-index 9

        h2
          font-size 16px
          color #222222
          height 20px
          line-height 20px
          display inline-block
          vertical-align middle
          border-left 3px solid themeColor
          padding-left 8px

      .close
        position absolute
        width 30px
        height 30px
        border none
        right 25px
        top 10px
        z-index 99
        border-radius 50%
        text-align center
        line-height 30px
        color #b8b8b8
        background-color #efefef
        transition 300ms
        cursor pointer
        font-size 15px

        &:hover
          background-color #e2e2e2
          color #909090

      .content
        margin-top -50px
        padding-top 50px
        width 100%
        height 100%
        position relative
        overflow scroll

        .nav
          height 50px
          line-height 50px
          border-bottom 1px solid #f6f6f6
          box-shadow 0 2px 3px #cccccc

          &::after
            content ""
            display block
            width 100%
            clear both

          .navlist
            margin-left 35px
            float left
            /*border 1px solid #f99*/
            /*border 1px solid #f60*/

            li
              display inline-block
              width 77px
              height 28px
              text-align center
              line-height 28px
              font-size 14px
              color #999999
              border-radius 5px
              margin-right 15px
              cursor pointer
              user-select none
              transition 300ms

              &:hover
                background-color #eeeeee

              &.on
                background-color themeColor
                color #ffffff

          .collect
            margin-right 26px
            color #999999
            font-size 12px
            float right
            cursor pointer
            transition 300ms
            user-select none

            &:hover
              color #666666

            i
              margin-right 2px

            &.on i
              color themeColor

    .screenShot
      border-radius 0

    .feedback
      .content
        overflow hidden

  /***
  设置Grid的全局样式
   */
  .v-table-class
    .v-table-header-row
      background-color #eeeeee

    .v-table-title-class
      font-size 14px
      color #666666

    .v-table-body-class
      font-size 14px
      color #888888

    .v-table-row
      transition 300ms

      .v-table-body-cell
        border-bottom 1px solid rgba(221, 221, 221, 0.5)

        .highlightLink
          cursor pointer
          text-decoration underline
          color themeColor
          transition 300ms

          &:hover
            color themeColor

  .pagination
    padding-top 15px
    text-align center


  /****
  日期选择器
   */
  .calendarPicker
    border 1px solid #eeeeee
    box-shadow 2px 2px 3px #cccccc

    header
      .next:after
        border-left 10px solid themeColor

      .prev:after
        border-right 10px solid themeColor

    .cell
      font-size 14px
      color #666666

    .cell.selected
      color #ffffff
      background-color themeColor

      &:hover
        background-color themeColor

    .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover
      border 1px solid themeColor


  /***
  下拉菜单
   */
  .v-select
    display inline-block

    input
      border none !important

  /***
  提示弹窗
   */
  .globalToast
    padding 20px 40px
    margin: 0 5px 5px;
    box-shadow 3px 3px 5px #333
    font-size: 12px;
    color: themeColor;
    background: #ffffff;
    border-left: 5px solid themeColor;

    .notification-title
      font-size 16px
      margin-bottom 20px

    .notification-content
      font-size 14px

    &.warn
      background: #ffb648;
      border-left-color: #f48a06;

    &.error
      background: #E54D42;
      border-left-color: #B82E24;

    &.success
      background: #68CD86;
      border-left-color: #42A85F;

  /*==============全局绿色版皮肤==============*/


  .globalToast
    color themeColor
    border-left-color themeColor

  //分页组件

  .pagination
    .v-page-li-active
      background-color themeColor

    .v-dropdown-items-li.active
      background-color themeColor

    .v-dropdown-selected:hover
      color themeColor
      border-color themeColor

    .v-page-goto-input:hover
      border-color themeColor

  .personal
    .appbox .wrapper .applist li .trangle
      border-color themeColor themeColor transparent transparent

    .main
      .searchResult .group > h2
        border-left-color themeColor !important

      .personalData .datalist li p span
        color themeColor

      .calendar
        .switch .switchContainer
          background-color themeColor

        .switch .switchContainer.false
          background-color themeColorShallow !important

      .calendar-comp
        .eventlist
          .selectDate
            color themeColor

            i
              color themeColor

            .highlightDate
              color themeColor

          .todolist
            .scrollTitle .wrapper .titlelist li div i.iconfont
              color themeColor

            li p i
              color themeColor

          .toDetail
            color themeColor

        div#calendarMain.monthCalendar .col.payload.today
          background-color themeColor !important

        .col.payload.today
          background-color themeColor !important

        .col.payload.event
          background-color themeColorShallow !important

        .col.payload.selected
          border 1px solid themeColorDeep !important

  .v--modal-overlay .generalbox
    .content
      .courseTableContainer > .inner .day li.vaild
        border-color themeColor !important

      .courseTableContainer > .innerMain ul.active, .courseTableContainer > .outer tr.week td.active
        background-color themeColorShallow !important

      .tableContainer .toServiceHandle, .tableContainer .toServiceHandle:hover
        color themeColor

      .nav .navlist li.on
        background-color themeColor

      .filter .btnGroup button, .filter .btnGroup button:hover
        background-color themeColor

      .v-table-class .v-table-row .v-table-body-cell .highlightLink, .v-table-class .v-table-row .v-table-body-cell .highlightLink:hover
        color themeColor

      //通知公告

      .noticeList li > h2 .inTop, .noticeList li > h2 .edit, .noticeList li > h2 .verify
        border-color themeColor
        color themeColor

      .fdblock > p::after
        background-color themeColor

      .fdblock .selectInfo .clearbtn
        color themeColor
        border-color themeColor

      .fdblock .peopleList li > span i
        color themeColor

      .fdblock .submitBtn
        color themeColor
        border-color themeColor

      .service-commit .submitBtn
        background-color themeColor

      .insideContent > h2 .verify
        color themeColor

      //服务详情

      .serviceIntroduce .desc-content > h2
        border-left-color themeColor

      .serviceIntroduce .right ul li p .tomap
        color themeColor

      .nav .collect.on i
        color themeColor

      //消息

      .timeline-list > li > h3 > span.month > span, .timeline-list > li > h3 > span.year, .timeline-list > li > h3 > span.month, .timeline-list > li > ul > li > ul > li
        color themeColor

      .timeline-list > li > ul > li > div > span
        border-color themeColor

      .search-container .search button:first-of-type
        background-color themeColor

      //开放预约

      .conditionList li .weekTable > .row > .col
        border-right-color themeColor

      .conditionList li .dateSelect > button, conditionList li .dateSelect > button:hover
        background-color themeColor

      //预约详情

      .manageView .stateDesc li span.can
        background-color themeColorShallow2

      .progress .progressContainer .all
        background-color themeColorShallow2

      //我的留言反馈

      .feedbackListContainer .feedbackList li > h2
        border-left-color themeColor

      .feedbackDetail .main .question > h3.describe::before, .feedbackDetail .main .answer > h3.describe::before
        background-color themeColor

      //在线预约

      .orderOnline .orderCalendar .calendar .row .col::after
        border-right-color themeColor

      .orderOnline .orderCalendar .calendar .row .col.today
        background-color themeColor

      .orderAction .main > ul li div > button, .orderAction .main > ul li div > button:hover
        background-color themeColor

      //编辑资料

      .editView .main .formContainer > .sign
        color themeColor

      .menu .menulist li.on
        border-bottom-color themeColor

      //个人资料

      .profile
        .main
          .contentlist li > h3 .confirmbtn, .contentlist li > h3 .confirmEmail
            border-color themeColor
            color themeColor

      //系统激活

      .stepGuide
        ul.stepList
          li.on
            background-color themeColorShallow2

            .trangle
              border-left-color themeColorShallow2

            span.num, h2
              color themeColor

      .emailConfirm button, .changePassword .submitPassword
        border-color themeColor
        color themeColor

      //日程

      .handle
        h3
          color themeColor

        .search.totoday i
          color themeColor

    //留言反馈

    &.feedback .submitBtn
      color themeColor
      border-color themeColor !important

  .v--modal-overlay .generalbox .header h2
    border-left-color themeColor

  .flatpickr-innerContainer
    .flatpickr-rContainer
      .flatpickr-days
        .dayContainer
          .flatpickr-day.selected
            background-color themeColor
            border-color themeColor

  //分页
  .v-page-li-active
    border-color themeColor
    background-color themeColor

    &.v-page-li-active:hover
      background-color themeColor

      a
        color #ffffff

  .v-page-li:hover

    border-color themeColor

    a
      color themeColor

  .v-dropdown-items-li.active
    background-color themeColor

  .v-page-jump-prev:hover i, .v-page-jump-next:hover i
    color themeColor

  .v-dropdown-items-li.active:hover
    background-color themeColor

  .v-page-goto-input:hover
    border-color themeColor
    color themeColor


  .v-dropdown-selected:hover
    border-color themeColor

    &::before
      color themeColor
    color themeColor


</style>
<!--下拉选择器样式表-->
<style src="static/css/multiselect.css"></style>



// WEBPACK FOOTER //
// src/pages/user.vue